<template>
  <div>
    <v-row class="mx-12">
      <template>
        <v-col
          v-for="(decision, index) in decisions"
          :key="index"
          cols="4"
        >
          <bankruptcy-card
            :info-item="decision"
            :icon="'mdi-bookshelf'"
            :header="decision.decisionType"
            :code-display-name="local.caseFile.cards.decision.codeDisplayName"
            :code="decision.code"
            :status=" decision.decisionStatus"
            :status-display-name="local.caseFile.cards.decision.statusDisplayName"
            :date="decision.decisionDate"
            :date-display-name="local.caseFile.cards.decision.dateDisplayName"
            :has-actions="true"
            :court-name="decision.courtName"
            :sub-circle-name="decision.subCircleName"
            :courtDegrees="decision.degreeId"
            @card-click="viewAttachment(decision)"
          >
          </bankruptcy-card>
        </v-col>
      </template>
      <v-col cols="12">
        <naj-no-data
          :has-data="decisions && decisions.length > 0"
          :loading="loading"
        ></naj-no-data>
      </v-col>
    </v-row>

    <pdf-modal
      v-if="selectedFile"
      ref="pdfModal"
      :file-name="selectedFile.fileName"
      :share-point-id="selectedFile.spid"
      @modalClose="hideViewAttachmentModal"
    >
    </pdf-modal>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import BankruptcyCard from '../bankruptcy-card.vue';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import PdfModal from '@/components/shared/pdf-modal/index.vue';
import { courtDegrees } from '@/helpers/enum';

export default {
  name: 'DecisionsTab',
  components: {
    BankruptcyCard,
    PdfModal,
  },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      decisions: [],
      selectedFile: null,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getDecisionsByRequestObjectKey']),
    loadData() {
      this.loading = true;
      this.getDecisionsByRequestObjectKey(this.requestObjectKey)
        .then((res) => {
          this.decisions = res.data;
        })
        .finally(() => {
          this.loading = false;
        });

    },
    viewAttachment(decision) {
      if (!decision.spid) { return; }
      this.selectedFile = decision;
      this.$nextTick(() => {
        var modal = this.$refs.pdfModal;
        modal.showModal();
      });
    },
    hideViewAttachmentModal() {
      this.selectedFile = null;
    },
    getView() {

    },
  },
};

</script>

<style lang="scss" scoped>
</style>
